import React, {useContext} from 'react'
import { StoreContext } from "../../context/StoreContext"
import './DirectEditSheet.scss'
const DirectEditSheet = () => {
    const { state } = useContext(StoreContext)

    return (
        <div className="direct-edit-sheet">
            Direct Edit Sheet
       </div>
    )
}

export default DirectEditSheet